<template>
  <svg
    v-if="color === 'default'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.18182 24L5 21.8182L14.8182 12L5 2.18182L7.18182 0L19.1818 12L7.18182 24Z"
      fill="var(--gray600)"
    />
  </svg>
  <svg
    v-else-if="color === 'primary'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.18182 24L5 21.8182L14.8182 12L5 2.18182L7.18182 0L19.1818 12L7.18182 24Z"
      fill="var(--brandPrimary)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      default: "default",
    },
  },
};
</script>
